import {
  IGenerateStrategyProps,
  IStrategy,
  IStrikeData,
  Leg,
} from "../../../types";
import { analyzePositions } from "../../analyzeProfits";
import { getSpreadMargin } from "../../strategyUtils";

export const generateBullPutSpread = (
  params: IGenerateStrategyProps,
  data: IStrikeData[],
  strategies: IStrategy[],
  expiryDuration: number
): IStrategy[] => {
  for (let i = data.length - 1; i >= 0; i--) {
    for (let j = i - 1; j >= 0; j--) {
      const legs: Leg[] = [
        {
          strikePrice: data[i].strikePrice,
          call: false,
          buy: false,
          quantity: -params.lotSize,
          price: data[i].PE?.lastPrice || 0,
        },
        {
          strikePrice: data[j].strikePrice,
          call: false,
          buy: true,
          quantity: params.lotSize,
          price: data[j].PE?.lastPrice || 0,
        },
      ];
      const analysis = analyzePositions(legs);
      const approxMargin = getSpreadMargin(
        params,
        legs[0].strikePrice,
        legs[1].strikePrice,
        legs[0].quantity
      );
      const maxLossROI = (analysis.maxLoss / approxMargin) * 100;
      const strategy: IStrategy = {
        title:
          "Bull put spread " +
          data[i].strikePrice +
          " - " +
          data[j].strikePrice,
        legs: legs,
        putBreakEven: analysis.breakEven.putBreakEven,
        putBreakEvenPercentage:
          ((analysis.breakEven.putBreakEven - params.data.underlyingValue) /
            params.data.underlyingValue) *
          100,
        maxLoss: analysis.maxLoss,
        maxProfit: analysis.maxProfit,
        riskRewardRatio: analysis.maxProfit / analysis.maxLoss,
        maxLossROI,
        maxProfitROI: (analysis.maxProfit / approxMargin) * 100,
        approxMargin: approxMargin,
        expiryDuration: expiryDuration,
        lotSize: params.lotSize,
        alert:
          maxLossROI > 15 ? "Max loss greater than 15% of cost" : undefined,
      };
      if (
        legs[0].price > 10 && //avoid non-liquid options
        legs[1].price > 10
      )
        strategies.push(strategy);
    }
  }
  return strategies;
};
